module.exports = __webpack_public_path__ + "static/media/image-technology-2.235cfd76.png";